<template>
  <div class="date-input">
    <SelectBox class="year" v-model.number="year">
      <option :value="0">--</option>
      <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
    </SelectBox>
    <strong class="unit">年</strong>
    <SelectBox class="month" v-model.number="month">
      <option :value="0">--</option>
      <option v-for="month in 12" :key="month" :value="month">{{ padZero(month) }}</option>
    </SelectBox>
    <strong class="unit">月</strong>
    <SelectBox class="day" v-model.number="day">
      <option :value="0">--</option>
      <option v-for="day in 31" :key="day" :value="day">{{ padZero(day) }}</option>
    </SelectBox>
    <strong class="unit">日</strong>
  </div>
</template>

<script>
import { times } from 'lodash'
import { padZero } from '@/utils/number'
import { splitDate } from '@/utils/date'
import SelectBox from '@/components/atoms/SelectBox'

/**
 * 日付入力
 */
export default {
  name: 'DateInput',
  components: {
    SelectBox,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: String,
    disabled: { type: Boolean, default: false },
  },
  computed: {
    date() {
      return splitDate(this.value)
    },
    years() {
      return times(new Date(new Date().getFullYear() + 5) - 1900 + 1, i => 1900 + i)
    },
    year: {
      get() {
        return this.date.year
      },
      set(year) {
        this.change(year, this.month, this.day)
      },
    },
    month: {
      get() {
        return this.date.month
      },
      set(month) {
        this.change(this.year, month, this.day)
      },
    },
    day: {
      get() {
        return this.date.day
      },
      set(day) {
        this.change(this.year, this.month, day)
      },
    },
  },
  methods: {
    padZero,
    change(year, month, day) {
      this.$emit('change', year || month || day ? `${year ? `${year}-` : ''}${padZero(month)}-${padZero(day)}` : null)
    },
  },
}
</script>

<style lang="postcss" scoped>
.date-input {
  font-size: 15px;

  .responsive & {
    @media screen and (--sp-size) {
      align-items: center;
      display: grid;
      grid-auto-flow: column;

      .select-box {
        width: 100%;

        &.year {
          min-width: 80px;
        }
      }

      .unit {
        margin: 0 4px;
      }
    }
  }
}

.year {
  width: 108px;
}

.month,
.day {
  width: 80px;
}
</style>
